export default __webpack_public_path__ + "static/media/aleksandr.aa5eacb4.jp2";